import { FunctionComponent, ReactNode } from 'react';
import { Grid } from 'react-styled-flexboxgrid';
import { useMedia } from 'react-use';

import { media } from '@savgroup-front-common/constants';

import { $Bannered } from './SelfcareBanner.styles';

export interface SelfcareBannerProps {
  bannerUrl?: string;
  children?: ReactNode;
}

const SelfcareBanner: FunctionComponent<SelfcareBannerProps> = ({
  bannerUrl,
  children,
}) => {
  const isGridFluidActive = useMedia(media.maxWidth.md);

  return (
    <$Bannered $bannerUrl={bannerUrl}>
      <Grid fluid={isGridFluidActive}>{children}</Grid>
    </$Bannered>
  );
};

export default SelfcareBanner;
